/**
 * Tag Editor Service
 * Loads and transforms the client IP tree into tag editor tree nodes.
 */

import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { ClientIpListService } from '../../../../client/client-ip-journal/client-ip-list/services/client-ip-list/client-ip-list.service'
import {
  ClientIPTreeCategory,
  ClientIPTreeNode,
} from '../../../../client/client-ip-journal/client-ip-list/types/ClientIPListTree'
import { TagEditorTreeData, TagEditorTreeNode } from '../tag-editor-tree-node'

@Injectable({ providedIn: 'root' })
export class TagEditorService {
  private readonly clientIpListService = inject(ClientIpListService)

  getTreeForClient(clientId: number): Observable<TagEditorTreeNode[]> {
    return this.clientIpListService
      .getFilteredTreeNodes(clientId)
      .pipe(map((nodes) => nodes.map((node) => this.transformNode(node))))
  }

  private transformNode(node: ClientIPTreeNode): TagEditorTreeNode {
    const data: TagEditorTreeData = {
      categoryId: node.data?.id || 0,
      categoryName: node.data?.type || ClientIPTreeCategory.PROGRAM_ENROLLMENT,
    }

    return {
      key: node.key || node.data?.id?.toString() || '',
      label: node.label || '',
      data,
      icon: node.icon || 'pi pi-tag',
      children: node.children?.map((child) => this.transformNode(child)),
    }
  }
}
